<template>
    <div class="flex flex-col lg:flex-row bg-background overflow-auto">
        <div class="flex lg:flex-1">
            <slot name="primarySide"></slot>
        </div>
        <div
            v-if="!fullscreenEnabled"
            class="flex justify-center flex-1 lg:items-center"
        >
            <slot name="secondarySide"> </slot>
        </div>
        <div>
            <slot name="portals"></slot>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'TheSplitLayout',
    computed: {
        ...mapGetters('ui', ['fullscreenEnabled']),
    },
};
</script>
